'use client'

import { useContentfulInspectorMode, useContentfulLiveUpdates } from '@ccpgames/eve-web-contentful'
import type { HTMLAttributes } from 'react'

type EntryWithSysId = {
  sys?: {
    id?: string | null
  } | null
}

export function useContentfulEntryLivePreview<TEntry extends EntryWithSysId>(entry: TEntry) {
  const updatedEntry = useContentfulLiveUpdates(entry) as TEntry
  const entryId = entry?.sys?.id ?? ''
  const getInspectorProps = useContentfulInspectorMode({ entryId })

  const inspectorProps = (fieldId: string): HTMLAttributes<HTMLElement> => {
    if (!entryId || !fieldId) {
      return {}
    }

    return (getInspectorProps({ fieldId }) ?? {}) as HTMLAttributes<HTMLElement>
  }

  return {
    updatedEntry,
    inspectorProps,
  }
}
